import React from "react";
import Header from "../components/Header";
import BottomNav from "../components/BottomNav";
import "../css/GameRates.css"
import Sidebar from "../components/SideBar";
import "../css/mainhome.css"; 
import { useState } from "react"; 
export default function GameRatesScreen() {
  const commonBids = [
    "Single - 10/95",
    "Jodi - 10/950",
    "Single Panna - 10/1400",
    "Double Panna - 10/2800",
    "Triple Panna - 10/7000",
    "Half Sangam - 10/10000",
    "Full Sangam - 10/100000",
  ];

  const kingStarline = [
    "Single - 10/95",
    "Single Panna - 10/1400",
    "Double Panna - 10/2800",
  ];

  const kingJackpot = [
    "Single - 10/95",
    "Jodi - 10/950",
  ];

  const [isSidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="mainhome-screen-wrapper">
       <Header walletCount={5} onMenuClick={() => setSidebarOpen(true)} />
            
                  {/* ⬅️ Move Sidebar here */}
                  {isSidebarOpen && (
                    <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
                  )}
      
      <div className="rates-container">
        <Section title="Game Win Ratio for All Bids" data={commonBids} />
        <Section title="King Starline Game Win Ratio" data={kingStarline} />
        <Section title="King Jackpot Win Ratio" data={kingJackpot} />

      </div>
      <BottomNav />
    </div>
  );
}

// function Section({ title, data }) {
//   return (
//     <div className="rate-section">
//       <div className="rate-header">{title}</div>
//       {data.map((item, index) => (
//         <div className="rate-card" key={index}>
//           {item}
//         </div>
//       ))}
//     </div>
//   );
// }

// function Section({ title, data }) {
//   return (
//     <div className="rate-section">
//       <div className="rate-header">{title}</div>

//       {data.map((item, index) => {
//         const [label, ratio] = item.split(" - ");

//         return (
//           <div className="rate-card" key={index}>
//             <span className="rate-label">{label}</span>
//             <span className="rate-ratio">{ratio}</span>
//           </div>
//         );
//       })}
//     </div>
//   );
// }
function Section({ title, data }) {
  return (
    <div className="rate-section">
      <div className="rate-header">{title}</div>

      <div className="rate-list">
        {data.map((item, index) => {
          const [label, ratio] = item.split(" - ");
          return (
            <div className="rate-row" key={index}>
              <span className="rate-name">{label}</span>
              <span className="rate-value">{ratio}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}


